<!-- <p>
  login-auth works!
</p> -->
<div *ngIf="!samlAuth">Not authorized</div>
